import {
    GET_DEED_REPORT
} from './DeedReport.actionsTypes';

export default function deedReport(state = [], action) {
    let newState = Object.assign([], state);
    switch (action.type) {
        case GET_DEED_REPORT:
            return [
                ...action.payload || [],
            ];
        case GET_DEED_REPORT:
            let reports = state.map(e => {
                return e
            })
            return reports
        default:
            return newState;
        }
}